import SiteNavbar from '@/pages/home/components/SiteNavbar';
import Hero from '@/pages/home/components/Hero';
import DistrictIndex from '@/pages/home/components/DistrictIndex';
import FeaturedChannels from '@/pages/home/components/FeaturedChannels';
import HotBoard from '@/pages/home/components/HotBoard';
import SubForumGrid from '@/pages/home/components/SubForumGrid';
import TagIndex from '@/pages/home/components/TagIndex';
import LatestFeed from '@/pages/home/components/LatestFeed';
import GuideSteps from '@/pages/home/components/GuideSteps';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <DistrictIndex />
        <FeaturedChannels />
        <HotBoard />
        <SubForumGrid />
        <TagIndex />
        <LatestFeed />
        <GuideSteps />
      </main>
      <SiteFooter />
    </div>
  );
}